export default function hasVariablePlaceholder(
  html: string,
  key: string
): boolean {
  const pattern = new RegExp(`\\{+${key}\\}+`, 'g');

  return pattern.test(html);
}
